<template>
  <div>
    <!-- Analisys IN_PROGRESS -->
    <v-progress-circular
      v-if="row.import_status === 'IN_PROGRESS'"
      indeterminate
      color="primary"
    ></v-progress-circular>

    <!-- Analisys SUCCEEDED -->
    <template v-else-if="row.prodImport || row.stageImport || row.playImport">
      <!-- Analisys PROD -->
      <v-tooltip bottom color="white" v-if="row.prodImport">
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            :color="row.prodImport.error ? 'error' : 'success'"
            v-on="on"
          >
            <v-icon v-if="row.prodImport.error" left>mdi-close</v-icon>
            <v-icon v-else left>mdi-checkbox-marked-circle</v-icon>
            production
          </v-chip>
        </template>
        <span v-if="row.prodImport.error" class="red--text">
          {{ row.prodImport.error.exceptionMessage }}
        </span>
        <span v-else class="black--text">
          This item is imported on the Prod environment.
        </span>
      </v-tooltip>

      <!-- Analisys STAGE -->
      <v-tooltip bottom color="white" v-if="row.stageImport">
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            :color="row.stageImport.error ? 'error' : 'success'"
            v-on="on"
          >
            <v-icon v-if="row.stageImport.error" left>mdi-close</v-icon>
            <v-icon v-else left>mdi-checkbox-marked-circle</v-icon>
            stage
          </v-chip>
        </template>
        <span v-if="row.stageImport.error" class="red--text">
          {{ row.stageImport.error.exceptionMessage }}
        </span>
        <span v-else class="black--text">
          This item is imported on the Stage environment.
        </span>
      </v-tooltip>

      <!-- Analisys PLAY -->
      <v-tooltip bottom color="white" v-if="row.playImport">
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            :color="row.playImport.error ? 'error' : 'success'"
            v-on="on"
          >
            <v-icon v-if="row.playImport.error" left>mdi-close</v-icon>
            <v-icon v-else left>mdi-checkbox-marked-circle</v-icon>
            play
          </v-chip>
        </template>
        <span v-if="row.playImport.error" class="red--text">
          {{ row.playImport.error.exceptionMessage }}
        </span>
        <span v-else class="black--text">
          This item is imported on the Play environment.
        </span>
      </v-tooltip>
    </template>
    <v-tooltip bottom color="white" v-else>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on">mdi-close</v-icon>
      </template>
      <span class="black--text">Hasn't imported yet</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => ({
        analyze_status: null,
        import_status: null
      })
    }
  },
  methods: {}
};
</script>
